import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation_inputs_filter } from '@shared/dto/generation/DTO__generation_inputs_filter';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_g_inputs__filter_set = (payload: DTO__generation_inputs_filter): PayloadAction<DTO__generation_inputs_filter> => ({
  type: ENUM__redux_action.UI_GENERATION_INPUTS__FILTER_SET,
  payload,
});

export function INIT_LOCAL__ui_g_inputs__filter_set(state: STATE__ui, action: PayloadAction<DTO__generation_inputs_filter>) {
  state.g_inputs__filter = action.payload;
}
